import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

import theme from "../../theme";

export const PageContainer = styled(Box)(() => ({
  height: "100%",
  width: "100%",
  backgroundColor: theme.palette.primary.dark,
  overflowX: "hidden",
}));

export const BackgroundImageContainer = styled(Box)(
  ({ src }: { src: string }) => ({
    width: "100%",
    height: "47%",
    objectFit: "cover",
  }),
);

export const ContentContainer = styled(Box)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "808px",
  height: "488px",
  borderRadius: "16px",
  backgroundColor: "white",
  textAlign: "center",
  alignItems: "center",
  display: "flex",
}));

export const MaintenanceHeader = styled(Typography)(() => ({
  color: theme.palette.primary.main,
  padding: "16px 0px",
  fontSize: "48px",
  fontWeight: 600,
  letterSpacing: "0.15px",
}));

export const MaintenanceInfo = styled(Typography)(() => ({
  fontWeight: 700,
  margin: "0px 32px",
}));
